module.exports = __webpack_public_path__ + "img/polygon-logo-switch-highlight.be831367.svg";